import styled from 'styled-components';

const TextAlignRight = styled.div`
  text-align: right;
`;

export default TextAlignRight;
